<template>
<div class="p-1" >
    <div v-if="net_data">
        <div class="vx-row mt-2 " v-for="(item, index) in data"  :key="index">
            <discipline-name v-if="item.discipline" :name="item.discipline.name"/>
            <vs-col vs-lg="12" class="vx-col mt-2" v-for="load in item.type_load" :key="'load_'+load.uid">
                <control-forms :selected="selected" :controlFormsData="controlFormsData" v-if="load.name=='Итоговая аттестация'"/>
                <not-control-forms :load="load"  v-else/>
            </vs-col>
        </div>
        <div v-if="!status_info">
            <vs-col class="mt-3" style="text-align: right;" v-if="!is_edvisor">
                <vs-button variant="primary"  @click="sendDataSelected()">
                    {{$t('send-advisor')}}
                </vs-button>
            </vs-col>
        </div>
    </div>
    <div v-else>
        <div class="con-vs-alert con-vs-alert-primary">
            <div class="vs-alert">{{ $t("no_data_text") }}</div>
        </div>
    </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {mapGetters} from "vuex";
import ControlForms from "@/pages/Home/RegistrationOfDisciplines/components/Modal/InsideContent/ControlForms";
import NotControlForms from "@/pages/Home/RegistrationOfDisciplines/components/Modal/InsideContent/NotControlForms";
import DisciplineName from "@/pages/Home/RegistrationOfDisciplines/components/Modal/InsideContent/DisciplineName";
export default {
    name: "ModalContent",
    components:{
        DisciplineName,
        NotControlForms,
        ControlForms,
        Multiselect
    },
    data() {
        return {
            nedata:false,
            selected: [],
        }
    },
    props: {
        controlFormsData:{
            required: false,
        },
        data:{
            required: false,
        }
    },
    computed:{
        user() {
            return this.$store.state.user.user
        },
        is_edvisor(){
            return this.$store.state.user.user.role.is_supervisor
        },
        ...mapGetters({
            limit:'regis_discepline/limitDiscepline',
        }),
        net_data(){
            let cond = this.data?(this.data.length == 0 || this.data == [] || this.data == undefined||this.data == null||this.data == false):(this.data == [] || this.data == undefined||this.data == null||this.data == false)
            return cond?false:true
        },
        ...mapGetters({
            obj: "regis_discepline/getFilter",
            GET_STATUS_INFO: 'regis_discepline/GET_STATUS_INFO',
        }),
        status_info(){
            if (this.user.role.is_student){
                return this.GET_STATUS_INFO?(this.GET_STATUS_INFO.code == 'CONFIRMED'||this.GET_STATUS_INFO.code == 'CHOSEN'):false
            }else{
                return this.GET_STATUS_INFO?(this.GET_STATUS_INFO.code == 'CONFIRMED'):false
            }
        },
    },
    watch:{
        async controlFormsData() {
            this.updateSelectCheckbox();
        },
    },
    methods:{
        updateSelectCheckbox() {
            this.controlFormsData.forEach((item) => {
                item.chosen_control_forms.forEach((c) => { this.selected[c] = true; });
            });
        },
        reloadPage(){
            this.$router.go(0)
        },
        async sendDataSelected(){
            if (this.limit.min >= this.limit.current){
                this.$vs.notify({
                    text: 'Вы не набрали нужное количество кредитов',
                    color: 'warning'
                })
                return false
            }
            var generateData = [];
            this.data.forEach(discepline => {
                discepline.type_load.forEach(function(type,index) {
                    generateData.push( type.student_discipline_uid )
                });
            });
            generateData = {'data':generateData,...this.$route.query}
            await this.$http.post(`user/student_discipline_view_set/selected_discipline_student/`,generateData)
                .then(async res=>{
                    this.$vs.notify({ title: this.$t('succesful'), color: "success" })
                    setTimeout(() =>{this.reloadPage()}, 1300)
                })
                .catch(e=>{ console.error(e); });
        }

    }
}
</script>

<style scoped>

</style>
